import React, { useState, useEffect, useRef } from 'react';
// import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Row, Col, Dropdown } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// utils
import { handleCatchError, handleAPIError } from 'utils/handleErrors';
// components
import AdminLoader from '../../../../../../components/loading/AdminLoader';
import LoadingPulse from '../../../../../../components/loading/LoadingPulse';
import Paginate from '../../../../../components/Paginate';
import ShippingCSV from '../../../../../../components/reactCsv/ShippingCSV';
import ShippingRow from './components/ShippingRow';
import ShippingCard from './components/ShippingCard';

// api
import { getAdminShippingsByUserId } from '../../../../../api/Api-admin';

const ShipmentHistory = () => {
  const title = 'Historial Envíos';
  const description = 'Historial Envíos Plataforma Ioenvio';
  const { crmUserId, userName } = useParams();
  const history = useHistory();
  // -Local States
  const [shipmentHistory, setShipmentHistory] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [changePage, setChangePage] = useState(1);
  const [changePageSize, setChangePageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  // - Use references to do scroll Up
  const startRef = useRef(null);
  const settingPage = (record) => {
    setChangePage(1);
    setChangePageSize(record);
  };
  // - Get all shippings
  const handlerGetShippingHistory = async () => {
    try {
      setIsLoading(true);
      const response = await getAdminShippingsByUserId(changePage, changePageSize, crmUserId);
      if (response.shippings !== undefined) {
        setShipmentHistory(response.shippings);
        setCurrentPage(response.current_page);
        setPageSize(response.page_size);
        setTotalPages(response.total_pages);
        setIsInitialLoading(false);
        if (startRef.current) {
          startRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (response.error) {
        handleAPIError(response);
      }
    } catch (error) {
      handleCatchError(error);
      setShipmentHistory(shipmentHistory); // para poder eliminar el loading del carrito que se setee con los datos anteriores
    } finally {
      setIsInitialLoading(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handlerGetShippingHistory();
  }, [changePage, changePageSize]);

  return (
    <>
      {isInitialLoading ? (
        <AdminLoader />
      ) : (
        <>
          {isLoading && <LoadingPulse />}
          {/* pageContainer I use it to add opacity screen while loading data */}
          <div id="pageContainer">
            <HtmlHead title={title} description={description} />
            {/* *** Title Start ***  */}
            <div className="page-title-container" ref={startRef}>
              <Row className="g-0">
                <Col className="col-auto mb-3 mb-sm-0 me-auto order-1">
                  <div className="muted-link pb-1 d-inline-block hidden breadcrumb-back cursor-pointer" onClick={() => history.goBack()}>
                    <CsLineIcons icon="chevron-left" size="13" />
                    <span className="align-middle text-small ms-1">Atrás</span>
                  </div>
                  <h1 className="mb-0 pb-0 display-4" id="title">
                    {title}
                  </h1>
                </Col>
              </Row>
            </div>
            {/* *** Title End ***  */}

            {/* *** Dropdown and Excel Buttons Start *** */}
            <h2 className="cta-1 text-primary mb-5 ">{userName}</h2>
            <Row className="g-0 d-flex justify-content-end aling-items-center">
              <Col xs="auto">{shipmentHistory?.length >= 10 && <ShippingCSV shippings={shipmentHistory} crmId={crmUserId} />}</Col>
              <Col xs="auto" className=" p-0 ms-2">
                <Dropdown align={{ xs: 'end' }} className={`d-inline-block ms-1 ${shipmentHistory?.length < 10 && 'invisible'}`}>
                  <Dropdown.Toggle variant="foreground-alternate" className="shadow sw-15">
                    {`${pageSize} Envios`}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow dropdown-menu-end">
                    <Dropdown.Item className={`${pageSize === 10 && 'd-none'}`} onClick={() => settingPage(10)}>
                      10 Envíos
                    </Dropdown.Item>
                    <Dropdown.Item className={`${pageSize === 20 && 'd-none'}`} onClick={() => settingPage(20)}>
                      20 Envíos
                    </Dropdown.Item>
                    <Dropdown.Item className={`${pageSize === 50 && 'd-none'}`} onClick={() => settingPage(50)}>
                      50 Envíos
                    </Dropdown.Item>
                    <Dropdown.Item className={`${pageSize === 100 && 'd-none'}`} onClick={() => settingPage(100)}>
                      100 Envíos
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {/* Length End */}
              </Col>
            </Row>
            <Row className="g-0 mb-3">
              <div className={`text-muted mt-3 ${shipmentHistory?.length < 2 && 'd-none'}`}>{`Página ${currentPage}`}</div>
            </Row>
            {/* *** Dropdown and Excel Buttons End *** */}
            {/* *** Main Page Start *** */}
            <div style={{ minHeight: '50vh' }} id="cardContainer">
              {/* List Header Start */}
              <ShippingRow />
              {/* List Header End */}
              {/* List shipment Items End */}
              {shipmentHistory?.length === 0 ? (
                <div className="py-5 mt-5 d-flex flex-column justify-content-center align-items-center w-50 m-auto">
                  {/* <h3 className="text-center mt-5">Error</h3> */}
                  <img alt="box" src="/img/animation/emptyBox.webp" style={{ width: '50px', height: '50px' }} />
                </div>
              ) : (
                <>
                  {/* List shipment Items Start */}
                  {shipmentHistory?.map((shipping, index) => (
                    <ShippingCard key={index} data={shipping} />
                  ))}
                  {/* List shipment Items End */}
                  {/* Pagination Start */}
                  <div className={`d-flex flex-column justify-content-center align-items-center mt-5 mx-auto ${totalPages < 2 && 'd-none'}`}>
                    <Paginate currentPage={currentPage} totalPages={totalPages} setCurrentPage={setChangePage} />
                  </div>
                  {/* Pagination End */}
                </>
              )}
            </div>
            {/* *** Main Page Start *** */}
          </div>
        </>
      )}
    </>
  );
};

export default ShipmentHistory;
